import React, { memo, useCallback } from "react";
import styled from "styled-components";
import color from "../../../helpers/color";
import radius from "../../../helpers/radius";
import transparentize from "../../../helpers/transparentize";
import MouseLabel from "../../Modules/MouseLabel";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-q8ok8g-0"
})(["position:relative;display:flex;align-items:center;"]);
const Option = /*#__PURE__*/styled.div.withConfig({
  displayName: "Option",
  componentId: "sc-q8ok8g-1"
})(["padding:3px;"]);
const Color = /*#__PURE__*/styled.div.withConfig({
  displayName: "Color",
  componentId: "sc-q8ok8g-2"
})(["", " width:15px;height:15px;background-color:", ";"], radius, ({
  active
}) => active ? color : transparentize);
const Filter = /*#__PURE__*/memo(({
  values,
  options,
  disabled,
  onChange
}) => {
  const onClick = useCallback(value => onChange(values.includes(value) ? values.filter(v => v !== value) : [...values, value]), [onChange, values]);
  return /*#__PURE__*/React.createElement(Root, null, options.map(({
    value,
    color,
    label
  }) => /*#__PURE__*/React.createElement(MouseLabel.Trigger, {
    key: value,
    label: label
  }, /*#__PURE__*/React.createElement(Option, {
    onClick: () => onClick(value)
  }, /*#__PURE__*/React.createElement(Color, {
    color: color,
    active: !disabled && values.includes(value)
  })))));
});
Filter.displayName = "Filter";
export default Filter;
//# sourceMappingURL=index.js.map